import * as i0 from '@angular/core';
import * as i1 from './theme-alain.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from '@angular/router';
import * as i5 from '@abp/ng.core';
import * as i6 from '@swimlane/ngx-datatable';
import * as i7 from '@abp/ng.theme.shared';
import * as i8 from '@fs-tw/theme-alain/layout';
import * as i9 from './components/application-layout/application-layout.component';
import * as i10 from './components/account-layout/account-layout.component';
import * as i11 from './components/empty-layout/empty-layout.component';
export const ThemeAlainModuleNgFactory:i0.NgModuleFactory<i1.ThemeAlainModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any,any> = (<any>(null as any));
var _decl0_3:i2.NgIf<any> = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵangular_packages_forms_forms_ba = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵangular_packages_forms_forms_z = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.NumberValueAccessor = (<any>(null as any));
var _decl0_16:i3.RangeValueAccessor = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i3.FormControlDirective = (<any>(null as any));
var _decl0_33:i3.FormGroupDirective = (<any>(null as any));
var _decl0_34:i3.FormControlName = (<any>(null as any));
var _decl0_35:i3.FormGroupName = (<any>(null as any));
var _decl0_36:i3.FormArrayName = (<any>(null as any));
var _decl0_37:i4.RouterOutlet = (<any>(null as any));
var _decl0_38:i4.RouterLink = (<any>(null as any));
var _decl0_39:i4.RouterLinkWithHref = (<any>(null as any));
var _decl0_40:i4.RouterLinkActive = (<any>(null as any));
var _decl0_41:i4.ɵangular_packages_router_router_l = (<any>(null as any));
var _decl0_42:i5.ɵl<any,any> = (<any>(null as any));
var _decl0_43:i5.ɵm = (<any>(null as any));
var _decl0_44:i5.ɵn = (<any>(null as any));
var _decl0_45:i5.ɵr = (<any>(null as any));
var _decl0_46:i5.ɵs = (<any>(null as any));
var _decl0_47:i5.ɵt = (<any>(null as any));
var _decl0_48:i5.ɵu = (<any>(null as any));
var _decl0_49:i5.ɵv = (<any>(null as any));
var _decl0_50:i5.ɵx = (<any>(null as any));
var _decl0_51:i5.ɵy = (<any>(null as any));
var _decl0_52:i5.ɵz = (<any>(null as any));
var _decl0_53:i5.ɵbb = (<any>(null as any));
var _decl0_54:i5.ɵbc = (<any>(null as any));
var _decl0_55:i6.DatatableComponent = (<any>(null as any));
var _decl0_56:i6.DatatableRowDetailDirective = (<any>(null as any));
var _decl0_57:i6.DatatableGroupHeaderDirective = (<any>(null as any));
var _decl0_58:i6.DatatableRowDetailTemplateDirective = (<any>(null as any));
var _decl0_59:i6.DataTableColumnDirective = (<any>(null as any));
var _decl0_60:i6.DataTableColumnHeaderDirective = (<any>(null as any));
var _decl0_61:i6.DataTableColumnCellDirective = (<any>(null as any));
var _decl0_62:i6.DataTableColumnCellTreeToggle = (<any>(null as any));
var _decl0_63:i6.DataTableFooterTemplateDirective = (<any>(null as any));
var _decl0_64:i6.DatatableFooterDirective = (<any>(null as any));
var _decl0_65:i6.DataTablePagerComponent = (<any>(null as any));
var _decl0_66:i6.DatatableGroupHeaderTemplateDirective = (<any>(null as any));
var _decl0_67:i7.ɵa = (<any>(null as any));
var _decl0_68:i7.ɵc = (<any>(null as any));
var _decl0_69:i7.ɵd = (<any>(null as any));
var _decl0_70:i7.ɵe = (<any>(null as any));
var _decl0_71:i7.ɵf = (<any>(null as any));
var _decl0_72:i7.ɵg = (<any>(null as any));
var _decl0_73:i7.ɵh = (<any>(null as any));
var _decl0_74:i7.ɵi = (<any>(null as any));
var _decl0_75:i7.ɵm = (<any>(null as any));
var _decl0_76:i7.ɵn = (<any>(null as any));
var _decl0_77:i7.ɵo = (<any>(null as any));
var _decl0_78:i7.ɵq = (<any>(null as any));
var _decl0_79:i7.ɵs = (<any>(null as any));
var _decl0_80:i7.ɵt = (<any>(null as any));
var _decl0_81:i7.ɵu = (<any>(null as any));
var _decl0_82:i7.ɵv = (<any>(null as any));
var _decl0_83:i7.ɵw = (<any>(null as any));
var _decl0_84:i7.ɵx = (<any>(null as any));
var _decl0_85:i8.LayoutBasicComponent = (<any>(null as any));
var _decl0_86:i8.LayoutBlankComponent = (<any>(null as any));
var _decl0_87:i8.LayoutPassportComponent = (<any>(null as any));
var _decl0_88:i9.ApplicationLayoutComponent = (<any>(null as any));
var _decl0_89:i10.AccountLayoutComponent = (<any>(null as any));
var _decl0_90:i11.EmptyLayoutComponent = (<any>(null as any));
var _decl0_91:i2.AsyncPipe = (<any>(null as any));
var _decl0_92:i2.UpperCasePipe = (<any>(null as any));
var _decl0_93:i2.LowerCasePipe = (<any>(null as any));
var _decl0_94:i2.JsonPipe = (<any>(null as any));
var _decl0_95:i2.SlicePipe = (<any>(null as any));
var _decl0_96:i2.DecimalPipe = (<any>(null as any));
var _decl0_97:i2.PercentPipe = (<any>(null as any));
var _decl0_98:i2.TitleCasePipe = (<any>(null as any));
var _decl0_99:i2.CurrencyPipe = (<any>(null as any));
var _decl0_100:i2.DatePipe = (<any>(null as any));
var _decl0_101:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_102:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_103:i2.KeyValuePipe = (<any>(null as any));
var _decl0_104:i5.ɵb = (<any>(null as any));
var _decl0_105:i5.ɵba = (<any>(null as any));
var _decl0_106:i5.CoreModule = (<any>(null as any));
var _decl0_107:i7.ThemeSharedModule = (<any>(null as any));
var _decl0_108:i8.LayoutModule = (<any>(null as any));
var _decl0_109:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_110:i0.ElementRef<any> = (<any>(null as any));
function _View_ApplicationLayoutComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_ApplicationLayoutComponent_1_0():void {
  var _any:any = (null as any);
}
function _View_AccountLayoutComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_AccountLayoutComponent_2_0():void {
  var _any:any = (null as any);
}
function _View_EmptyLayoutComponent_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_EmptyLayoutComponent_3_0():void {
  var _any:any = (null as any);
}
